<template>
	<div class="display-flex">
		<div class="pr-2">
			<SIcon name="tool-play" />
		</div>
		<div class="flex-centerize">
			<h1 class="med">New Tool</h1>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ToolHeaderTitle',
};
</script>

<style lang="scss" scoped></style>
